import React, { FunctionComponent } from "react";
import { SpeakerListItemProps } from "../interfaces";

const SpeakerListItem: FunctionComponent<SpeakerListItemProps> = ({
  speaker,
}) => {
  const { name, image, title, position, company } = speaker;
  return (
    <div className="speakerListItem">
      <div className="speakerListItemImage">
        <img src={image} alt={name} title={name} />
      </div>
      <div className="speakerInfo">
        <div className="speakerName">{name}</div>
        <div className="speakerTitle">
          {position},<br /> {company}
        </div>
      </div>
    </div>
  );
};

export default SpeakerListItem;
